import React, { forwardRef } from 'react';
import Lottie, { LottieRef, LottieRefCurrentProps } from 'lottie-react';

export interface LottieControllerProps {
  animationData: object;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
  ref?: React.RefObject<LottieRefCurrentProps>;
  className?: string;
}

const LottieAnimation = forwardRef<LottieRefCurrentProps, LottieControllerProps>(
  ({ animationData, loop, autoplay, style, className }, ref) => {
    return (
      <Lottie
        lottieRef={ref as LottieRef}
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        style={style}
        className={className}
      />
    );
  }
);

export default LottieAnimation;